module.exports = __webpack_public_path__ + "img/banner4.8ddd8c3.png";